import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useLocation } from "react-router-dom";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import { paypalSubscription, stripeDecode, updatePayment, updateBundlePayment } from "./service";
import { setSubscriptionPageSkip } from "../../../Redux/TVcode/tvCodeSlice";
import Translate from "../../../Components/Multilanguage/Translate";
import { bogSubscriptionCheck } from "../../../Screens/Subscription/service";
import { toast } from "react-toastify";

const PaymentSuccess = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const isFromLinkTv = useSelector((state) => state?.tv?.subscriptionPageSkip)
  const tvCode = useSelector((state) => state?.tv?.tvCode);  
  const location = useLocation();

  let isFromAndroid = localStorage.getItem("isAndroid");
  let subscription_id = localStorage.getItem("subscription_id");
  let bogOrderId = localStorage.getItem("bogOrderId");

  const [paymentSuccess, setPaymentSuccess] = useState(false)
  const [successMsg, setSuccessMsg] = useState("");
  const [isBundlePaymentSuccess, setIsBundlePaymentSuccess] = useState(false);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const urlParams = new URLSearchParams(window.location.search);
  useEffect(() => {

    const sessionId = urlParams.get("session_id");
    const paypalData = urlParams.get("token")
      ? urlParams.get("token")
      : urlParams.get("amt");
    const paypalSubId = urlParams.get("sub_id");
    const ideabizData = location?.state?.ibr;
    const cinetPayFlag = urlParams.get("cinetPay")
    const squareFlag = urlParams.get("square")
    const method = urlParams.get("method");
    if (method == 'cashfree') {
      setTimeout(() => {
        setPaymentSuccess(true);
      }, 3000);
    }
    if (sessionId) {
      fetchStripeDecode(sessionId)
    } else if (paypalData) {
      let modeOfPayment = "paypal"
      updatePaymentApi(paypalData, modeOfPayment, null, paypalSubId)
    } else if (ideabizData) {
      let modeOfPayment = "ideabiz"
      updatePaymentApi(ideabizData, modeOfPayment)
    } else if (cinetPayFlag) {
      setPaymentSuccess(true)
    } else if (squareFlag) {
      let modeOfPayment = "square"
      let receiptid = subscription_id;
      updatePaymentApi(receiptid, modeOfPayment)
    } else if (bogOrderId) {
      BogSubscriptionStatus();
    }
  }, []);

  const paypalSusbscriptionApi = () => {
    const subID = localStorage.getItem("selectedSubId");

    let myInterval = setInterval(async () => {
      const response = await paypalSubscription(appInfo, subID);
      if (response?.status === 201) {
        clearInterval(myInterval);
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          window.location.href = process.env.REACT_APP_WEB_VIEW_SUCCESS;// android succes redirect
        } else {
          // setIsLoading(false);
          // setIsSucces(true);
        }
      }
    }, 10 * 1000)
  }

  const updatePaymentApi = async (subscription, modeOfPayment, isUpgrade, subscriptionId) => {
    try {
      const updatePaymentResponse = await updatePayment(appInfo, subscription, modeOfPayment, "success", isUpgrade, subscriptionId);
      if (updatePaymentResponse?.status === 200) {
        const iosSignup = localStorage.getItem("iosSignup")

        setPaymentSuccess(true)
        setSuccessMsg(updatePaymentResponse?.data?.message);
        // localStorage.removeItem("couponId");
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          // localStorage.removeItem("isAndroid");
          // window.location.href = window.location.origin + "/webviewsuccess";  // android success redirect
          window.location.href = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_SUCCESS_URL;  // android success redirect 
        } else if (iosSignup == 'true') {
          localStorage.removeItem("iosSignup");
          const userId = localStorage.getItem("userId");
          setTimeout(() => {
            window.location.href = appInfo?.projectDetails?.projectConfig.config.APPLINK_URL + "?user_id=" + userId + "&token=" + appInfo?.projectDetails.device_id;  // ios success redirect
          }, 2000);
        } else {
          // setIsLoading(false);
          // setIsSucces(true);
        }

      }

    } catch (err) {
      const response = await updatePayment(appInfo, subscription, modeOfPayment, "failed", null, subscriptionId);
      if (response?.status === 200) {
        setPaymentSuccess(true)
        setSuccessMsg(response?.data?.message);
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          // localStorage.removeItem("isAndroid");
          // window.location.href = window.location.origin + "/webviewfailed";; // android error redirect
          window.location.href = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_FAILED_URL;  // android success redirect 
        } else {
          navigate("/payment-failed")
        }
      }

    }
  }


  const fetchStripeDecode = async (sessionId) => {
    const stripeDecodeResponse = await stripeDecode(appInfo, sessionId)
    if (stripeDecodeResponse?.status === 200) {
      const stripeData = stripeDecodeResponse?.data?.data || {};
      const subscriptionId = stripeDecodeResponse?.data?.data?.metadata?.sub_id;
      const subscription = stripeData?.subscription;;
      const metadata =
        stripeData?.metadata ||
        stripeData?.session?.metadata ||
        stripeData?.payment_intent?.metadata ||
        {};

      if (metadata?.purchase_type === "bundle") {
        const bundleId = parseInt(metadata?.bundle_id, 10);
        const currencyId = parseInt(metadata?.currency_id, 10);
        const amountFromMetadata = parseFloat(metadata?.price_paid);
        const amountFromSession = Number(stripeData?.amount_total);
        const amountFromIntent = Number(stripeData?.payment_intent?.amount);
        const normalizedAmount =
          !Number.isNaN(amountFromMetadata) && Number.isFinite(amountFromMetadata)
            ? amountFromMetadata
            : Number.isFinite(amountFromSession)
              ? amountFromSession / 100
              : Number.isFinite(amountFromIntent)
                ? amountFromIntent / 100
                : 0;

        const paymentRef = stripeData?.payment_intent


        const bundlePurchaseResponse = await updateBundlePayment(
          appInfo,
          bundleId,
          "stripe",
          paymentRef,
          normalizedAmount,
          currencyId
        );
        const isAndroid = localStorage.getItem("isAndroid");
        if (bundlePurchaseResponse?.status === 200 && bundlePurchaseResponse?.data?.success) {
          const purchaseData = bundlePurchaseResponse?.data?.data || {};
          const tokenId = Number(purchaseData?.token_id);
          const newBalance = Number(purchaseData?.new_balance);
          const existingUserCoins =
            typeof userDetails?.user_coins === "object" && userDetails?.user_coins !== null
              ? userDetails?.user_coins
              : {};

          const updatedUserCoins = {
            ...existingUserCoins,
            token_id: tokenId,
            token_name: purchaseData?.token_name || existingUserCoins?.token_name || "Coins",
            token_symbol: purchaseData?.token_symbol || existingUserCoins?.token_symbol || "",
            current_balance: newBalance,
          };

          dispatch(
            getUserDetails({
              userDetails: {
                ...(typeof userDetails === "object" && userDetails !== null ? userDetails : {}),
                user_coins: updatedUserCoins,
              },
            })
          );

          setPaymentSuccess(true);
          setIsBundlePaymentSuccess(true);
          setSuccessMsg(bundlePurchaseResponse?.data?.message || "Payment successful");
          if (isAndroid == "true") {
            const rediredctUrl = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_SUCCESS_URL + "?bundle=true" ;
            window.location.href = rediredctUrl;  // android success redirect 
          }
        } else {
          if (isAndroid == "true") {
            const rediredctUrl = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_FAIL_URL + "?bundle=true" ;
            window.location.href = rediredctUrl;  // android fail redirect 
          }
          navigate("/payment-failed");
        }
        return;
      }

      let modeOfPayment = 'stripe';
      const isUpgrade = localStorage.getItem('isUpgrade') == 'true' ? true : false;
      updatePaymentApi(subscription, modeOfPayment, isUpgrade, subscriptionId)
    }
  }

  const handleClick = () => {
    const showId = localStorage.getItem("showId");
    const eventId = localStorage.getItem("eventId");
    const channelId = localStorage.getItem('channelId');
    const eventType = localStorage.getItem("eventType");
    const vanityUrl = localStorage.getItem("vanityUrl")
    const verticalShowRedirect = localStorage.getItem("vertical_show_redirect");
    const isAndroid = localStorage.getItem("isAndroid")
    const iosSignup = localStorage.getItem("iosSignup")
    if (isFromLinkTv) {
      dispatch(setSubscriptionPageSkip({ value: false }));
      if (tvCode) {
        navigate(`/tv?code=${tvCode}`, { state: { subscriptionPage: false } })
      } else {
        navigate("/tv", { state: { subscriptionPage: false } })
      }
    } else if (isAndroid == "true") {
      // window.location.href = window.location.origin + "/webviewsuccess";  // android success redirect
      window.location.href = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_SUCCESS_URL;  // android success redirect 
    } else if (iosSignup == 'true') {
      localStorage.removeItem("iosSignup");
      const userId = localStorage.getItem("userId");
      setTimeout(() => {
        window.location.href = appInfo?.projectDetails?.projectConfig.config.APPLINK_URL + "?user_id=" + userId + "&token=" + appInfo?.projectDetails.device_id;  // ios success redirect
      }, 2000);
    } else if (eventId) {
      if (eventType === "UPCOMING") {
        navigate(`/event/${vanityUrl}`, { state: { eventId: eventId }, replace: true },)
      } else {
        navigate(`/player`, { state: { eventId: eventId }, replace: true })
      }
    } else if (channelId) {
      navigate(`/live`, { state: { channelId } })
    } else {
     if (isBundlePaymentSuccess && verticalShowRedirect) {
        try {
          const redirectData = JSON.parse(verticalShowRedirect);
          localStorage.removeItem("vertical_show_redirect");

          if (redirectData?.vanityUrl) {
            navigate(redirectData.vanityUrl, {
              replace: true,
              state: {
                resumeFromBundlePurchase: true,
                pendingConsumptionType: redirectData?.consumptionType,
                pendingVideoId: redirectData?.videoId,
                pendingShowId: redirectData?.showId,
              },
            });
            return;
          }
        } catch (error) {
          localStorage.removeItem("vertical_show_redirect");
        }
      }

     if (vanityUrl?.trim()) {
        navigate(`/show-details/${vanityUrl}`, { state: { showId }, replace: true});
      } else {
        navigate(`/home`);
      }
    }
    setTimeout(() => {
      // Forces a full reload of the new page to call athe authentication API to reset the resubscribe flag
      if (userDetails?.user_subscription_id) {
        window.location.href = window.location.href;
      }
    }, 2000);
  }
  let intervalId = null; 
  const BogSubscriptionStatus = async () => {
    
    if (!bogOrderId) return;
  
    let retries = 0;
    const MAX_RETRIES = 36; 
  
    const checkStatus = async () => {
      try {
        const response = await bogSubscriptionCheck(appInfo, bogOrderId);
  
        if (response?.data?.status === "SUCCESS") {
            let modeOfPayment = "bog"
            await updatePaymentApi(bogOrderId, modeOfPayment);
            clearInterval(intervalId); 
            intervalId = null;
        } else if (retries >= MAX_RETRIES) {
          clearInterval(intervalId); 
          intervalId = null;
        } else {
          retries++;
        }
      } catch (error) {
         toast.error(error?.response?.data?.message, { position: "bottom-center", });
      }
    };
  
    if (!intervalId) {
      intervalId = setInterval(checkStatus, 5000); 
    }
  };

  if (paymentSuccess) {
    return (
      <div className="success">
        <div className="successContainer">
          <div className="checkIcon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="92"
              height="92"
              fill="#fff"
              className="bi bi-check2"
              viewBox="0 0 16 16"
            >
              <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
            </svg>
          </div>
          <h5><Translate textKey={'success'} /></h5>
          <p>{successMsg}</p>
          {
            isFromAndroid !== "true" &&
            <button onClick={() => handleClick()}><Translate textKey={'ok'} /></button>
          }
        </div>
      </div>
    );

  } else {
    return (
      <div className="success">
        <div className="successContainer">
          <p className="checking"><Translate textKey={'payment_checking_inprogress'} /></p>

        </div>
      </div>
    )
  }
};

export default PaymentSuccess;
